import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ProtocolService } from '../../../../services/protocol.service';
import { Protocol } from '../../../../models/protocol/protocol.model';
import { Subscription } from 'rxjs';
import { Utilities } from '../../../../services/utilities';
import { MessageSeverity, AlertService } from '../../../../services/alert.service';
import { FullProtocol } from '../../../../models/protocol/full-protocol.model';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-view-protocol',
  templateUrl: './view-protocol.component.html',
  styleUrls: ['./view-protocol.component.css'],
  imports: [
    CommonModule
  ],
  encapsulation: ViewEncapsulation.None
})
export class ViewProtocolComponent implements OnInit {
  protocolId: number = this.route.snapshot.params.protocolId;
  visitAnchor: string = this.route.snapshot.params.visitAnchor;

  constructor(
    private protocolService: ProtocolService,
    private alertService: AlertService,
    private route: ActivatedRoute
  ) { }

  protocol: FullProtocol = null;

  subscription: Subscription = new Subscription();

  ngOnInit() {
    console.log(`ProtocolID: ${this.protocolId} Anchor: ${this.visitAnchor}`);
    this.subscription.add(
      this.protocolService.getFullProtocolById(this.protocolId).subscribe({
        next: response => {
          //console.log("got a response");
          console.log(response);
          this.protocol = response;

          setTimeout(() => {
            if (this.visitAnchor) {
              (document.getElementById('#' + this.visitAnchor) as HTMLElement).scrollIntoView({ behavior: 'smooth' });
            }
          },1000);          
        },
        error: (error) => {
          const httpError = Utilities.getHttpResponseMessage(error);
          this.alertService.showStickyMessage(
            'Protocol Error',
            `Unable to retrieve protocol from the server.\r\nErrors: "${httpError}"`,
            MessageSeverity.error,
            error
          );
        }
      })
    );
  }
}
